import createReducer, { ActionCreatorHelper } from 'store/createReducer';
import { AccountId } from 'store/models/accounts';

type UserId = number | null;
type IsGiftModalVisible = boolean;

// ----------------------- actions -------------------------------------
const SET_GIFT_ACCOUNT_ID = 'SET_GIFT_ACCOUNT_ID';
const SET_GIFT_USER_ID = 'SET_GIFT_USER_ID';
const SET_GIFT_SHOW_MODAL = 'SET_GIFT_SHOW_MODAL';

interface PayloadTypes {
    [SET_GIFT_ACCOUNT_ID]: AccountId;
    [SET_GIFT_USER_ID]: UserId;
    [SET_GIFT_SHOW_MODAL]: IsGiftModalVisible;
}

const ActionCreator = ActionCreatorHelper<PayloadTypes>();

export const setAccountId = ActionCreator(SET_GIFT_ACCOUNT_ID);
export const setUserId = ActionCreator(SET_GIFT_USER_ID);
export const setGiftModalVisible = ActionCreator(SET_GIFT_SHOW_MODAL);
// ----------------------- /actions -------------------------------------

// ----------------------- reducer --------------------------------------
interface GiftState {
    accountId: AccountId;
    userId: UserId;
    isGiftModalVisible: IsGiftModalVisible;
}

export const GIFT_INITIAL_STATE = {
    accountId: null,
    userId: null,
    isGiftModalVisible: false,
};

export default createReducer<GiftState, PayloadTypes>(GIFT_INITIAL_STATE, {
    [SET_GIFT_ACCOUNT_ID]: (state, { payload }) => ({
        ...state,
        accountId: payload,
    }),
    [SET_GIFT_USER_ID]: (state, { payload }) => ({
        ...state,
        userId: payload,
    }),
    [SET_GIFT_SHOW_MODAL]: (state, { payload }) => ({
        ...state,
        isGiftModalVisible: payload,
    }),
});
// ----------------------- /reducer --------------------------------------
